import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'

export default class FullWidth extends React.Component {
  render() {
    const content = this.props.content
    // console.log(content)
    return (
      <ScrollAnimation
        className="transable"
        animateIn="move-up"
        animateOnce={true}
        delay={200}
      >
        <section
          className="full-width-container"
          dangerouslySetInnerHTML={{
            __html: content.content
          }}
        />
      </ScrollAnimation>
    )
  }
}
